// extracted by mini-css-extract-plugin
export var textInput = "_ed-0";